import { SET_BM_ENV } from '../constants'

const config = (state: object = {}, action: any) => {
  switch (action.type) {
    case SET_BM_ENV:
      return Object.assign({}, state, action)
    default:
      return state
  }
}
export default config



// WEBPACK FOOTER //
// ./src/reducers/config.tsx